export default "__VITE_ASSET__56006194__"